@if (isMobile()) {
  <div
    display="dynamic"
    placement="bottom-start"
    #d="ngbDropdown"
    [autoClose]="'outside'"
    ngbDropdown>
    <button
      class="filter-trigger-btn"
      ngbDropdownToggle>
      @if (activeTag()) {
        <span class="filter-badge">
          <span class="visually-hidden">Filter applied</span>
        </span>
      }
      <i class="iconoir-view-grid"></i>
    </button>
    <div
      class="border-0 tags-dropdown"
      ngbDropdownMenu>
      @if (d.isOpen()) {
        <div class="card shadow border-opacity-25 dropdown-enter">
          <div class="card-body">
            <ng-container
              [ngTemplateOutlet]="tagsTemplate"
              [ngTemplateOutletContext]="{ $implicit: tags }"></ng-container>
          </div>
        </div>
      }
    </div>
  </div>
} @else {
  <ng-container
    [ngTemplateOutlet]="tagsTemplate"
    [ngTemplateOutletContext]="{ $implicit: tags }"></ng-container>
}
<ng-template
  #tagsTemplate
  let-tags>
  <div class="row g-2">
    @for (tag of tags; track tag.slug) {
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-sm min-w-auto"
          [ngClass]="isActive(tag.slug) ? 'btn-secondary' : 'btn-light-on-white'"
          (click)="onTagClick(tag.slug)">
          {{ tag.name }}
        </button>
      </div>
    }
  </div>
</ng-template>
